import { Element, OneOf3 } from '@design-systems/utils';
// eslint-disable-next-line import/no-extraneous-dependencies
import preval from 'preval.macro';

export type Sizes = ['x-small', 'small', 'medium', 'large', 'x-large'];

export const IconSizeMap = preval`
  const tokens = require('@design-tokens/intuit')

  module.exports = {
    sizeXSmall: String(tokens.lightComponents.icon.iconXSmallDefaultSize),
    sizeSmall: String(tokens.lightComponents.icon.iconSmallDefaultSize),
    sizeMedium: String(tokens.lightComponents.icon.iconMediumDefaultSize),
    sizeLarge: String(tokens.lightComponents.icon.iconLargeDefaultSize),
    sizeXLarge: String(tokens.lightComponents.icon.iconXLargeDefaultSize)
  }
`;

export const IconSizes: Record<Sizes[number], string> = {
  'x-small': IconSizeMap.sizeXSmall,
  small: IconSizeMap.sizeSmall,
  medium: IconSizeMap.sizeMedium,
  large: IconSizeMap.sizeLarge,
  'x-large': IconSizeMap.sizeXLarge
} as const;

export interface IconPropsSize {
  /** The size of the icon */
  size: Sizes[number];
}

export interface IconPropsInline {
  /** Whether the Icon inherits text styles */
  inline: true;
}

export interface IconPropsOverride {
  /** The width of the icon */
  width: string;
  /** The height of the icon */
  height: string;
}

export type IconProps = OneOf3<
  IconPropsSize,
  IconPropsInline,
  IconPropsOverride
> &
  Element<'svg'>;
